<div class="container-fluid dashboard-container">
  
  <!-- Welcome Area Header -->
  <div class="welcome-header-section d-flex justify-content-between align-items-center flex-wrap mb-4">
    <div class="welcome-text-group">
      <h1 class="welcome-title">Welcome back, {{ username || 'Sub Admin' }}!</h1>
      <p class="welcome-subtitle">Access and manage your systems from here.</p>
    </div>
    
    <!-- Date & Time Card Widget -->
    <div class="date-time-widget-card d-flex align-items-center">
      <div class="calendar-icon-box d-flex align-items-center justify-content-center">
        <i class="fa-regular fa-calendar-days"></i>
      </div>
      <div class="date-time-info d-flex flex-column">
        <span class="current-date-text">{{ today | date:'dd MMM yyyy, EEEE' }}</span>
        <span class="current-time-text">{{ today | date:'hh:mm a' }}</span>
      </div>
    </div>
  </div>

  <!-- Cards Grid Row -->
  <div class="row m-0 justify-content-center card-grid-row">
    
    <!-- Configuration Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="ConfigurationAllow">
      <div class="dashboard-card config-card" (click)="OnConfigClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-sliders"></i>
        </div>
        <h3 class="card-title">CONFIGURATION</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Configuration Management</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>

    <!-- LOS Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="QUICKLOANAllow">
      <div class="dashboard-card los-card" (click)="OnQuickLoanClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-file-invoice-dollar"></i>
        </div>
        <h3 class="card-title">LOS</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Loan Origination System</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
    <!-- LMS Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="LMSAllow">
      <div class="dashboard-card lms-card" (click)="OnLMSClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-hand-holding-dollar"></i>
        </div>
        <h3 class="card-title">LMS</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Loan Management System</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
    <!-- Accounting Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="ACCOUNTINGAllow">
      <div class="dashboard-card accounting-card" (click)="OnAccountingClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-calculator"></i>
        </div>
        <h3 class="card-title">ACCOUNTING</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Integrated GL Accounting</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
    <!-- Reports Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="REPORTAllow">
      <div class="dashboard-card reports-card" (click)="OnReportsClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-chart-pie"></i>
        </div>
        <h3 class="card-title">REPORTS</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Management Reports</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
    <!-- Deposits Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="DEPOSITAllow">
      <div class="dashboard-card deposit-card" (click)="OnDepositClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-piggy-bank"></i>
        </div>
        <h3 class="card-title">DEPOSITS</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Public Deposits</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
    <!-- Managed Portfolio Card -->
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex" *ngIf="PORTFOLIOAllow">
      <div class="dashboard-card portfolio-card" (click)="OnpPartnerClick()">
        <div class="grid-dot-pattern"></div>
        <div class="card-bg-blob"></div>
        
        <div class="card-icon">
          <i class="fa-solid fa-briefcase"></i>
        </div>
        <h3 class="card-title">MANAGED PORTFOLIO</h3>
        <div class="card-accent-line"></div>
        <p class="card-description">Landing Partner Fund Portfolio</p>
        <button class="card-access-btn">
          Access <span class="btn-arrow">&rarr;</span>
        </button>
      </div>
    </div>
    
  </div>
</div>
